import React, { useState, useEffect } from "react";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import { WBLabel, WBTitleLabel } from "./WBLabel";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SlideAlertAction ({
    title,
    subTitle,
    cancelAction = () => {},
    okAction = () => {},
    cancelActionTitle,
    okActionTitle,
    isOpen,
    setIsOpen,
    type,
    actionBody
}) {

    const handleClose = () => {
        setIsOpen(false)
    }

    return (
        <Dialog
            fullWidth={false}
            maxWidth={'sm'}
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            PaperProps={{
                style: {backgroundColor: '#FFFFFFF2', minWidth: window.innerWidth >= 600 ? window.innerWidth >= 900 ? '20%' : '40%' : '50%', 
                    maxWidth: window.innerWidth >= 600 ? window.innerWidth >= 900 ? '20%' : '40%' : '50%',
                    textAlign: 'center'
                }
            }}
          >
            <div style={{paddingTop: 12, marginLeft: 2, marginRight: 2}}>
                <WBTitleLabel>{title}</WBTitleLabel>
            </div>
            <DialogContent style={{ paddingTop: 10}}>
              <DialogContentText id="alert-dialog-slide-description" style={{ marginLeft: 2, marginRight: 2 }}>
                <WBLabel>{subTitle}</WBLabel>
                {
                    actionBody &&
                    <div onClick={() => { handleClose()}}>
                        {actionBody}
                    </div>
                }
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{padding: 0}}>
                <div style={{display: 'flex', width: '100%'}}>
                    {
                        type !== "confirm" &&
                        <div 
                            onClick={() => {
                                handleClose();
                                cancelAction();
                            }} 
                            style={{fontSize: 10, width: '50%', textAlign: 'center', color: 'red', borderRight: '0.01em solid #344767', borderTop: '0.01em solid #344767'}}>
                            <div style={{padding: 6}}><WBLabel>{cancelActionTitle ? cancelActionTitle : "Cancel"}</WBLabel></div>
                        </div>
                    }
                    <div
                        onClick={() => okAction()} 
                        style={{width: type !== "confirm" ? '50%' : '100%', textAlign: 'center', color: '#f3278b', borderTop: '0.01em solid #344767'}}>
                        <div style={{padding: 6}}><WBLabel style={{fontWeight: 'bold'}}>{okActionTitle ? okActionTitle : "OK"}</WBLabel></div>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default SlideAlertAction;